import React from "react";
import { Typography } from "@mui/material";
interface TermsAndConditionsTextProps {
  content: string;
}
const TermsAndConditionsText: React.FC<TermsAndConditionsTextProps> = ({ content }) => {
  const processContent = (content: string) => {
    const urlRegex = /(?:https?:\/\/|www\.)[^\s<.]+\.[^\s<]+/g;
    return content.replace(urlRegex, (url: string) => {
      const href = url.startsWith("http") ? url : `http://${url}`;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: #0096aa; text-decoration: underline;">${url}</a>`;
    });
  };
  return (
    <Typography
      variant="body1"
      component="div"
      sx={{ fontSize: "13px", mt: "15px" }}
      dangerouslySetInnerHTML={{
        __html: processContent(content),
      }}
    />
  );
};
export default TermsAndConditionsText;
